import { Placement } from "@galaxy-io/dls/theme/enums";
import { ToastVariant } from "@galaxy-io/dls/toast/Toast";
import type { ToastOptions } from "@galaxy-io/dls/toast/useToast";

/** Failures remain dismissible; successful actions leave enough time to read. */
export function toastDefaults(
  variant: ToastVariant,
): Pick<ToastOptions, "placement" | "isPersistent" | "duration"> {
  return {
    placement: Placement.BOTTOM_END,
    isPersistent: variant === ToastVariant.ERROR || variant === ToastVariant.WARNING,
    duration: 5000,
  };
}
